import { orderUploadFileUploadStyles } from "@insite/content-library/Widgets/OrderUpload/OrderUploadFileUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderUploadFileUploadStyles.orderUploadStyles = {
    downloadTemplateButton: {
        variant: "primary",
        css: css`
            margin-bottom: 2rem;
        `,
    },
    fileUploader: {
        buttonProps: {
            variant: "secondary",
            css: css`
                margin: 26px 0 0 15px;
            `,
        },
        labelProps: {
            css: css`
                text-transform: inherit;
            `,
        },
    },
    uploadLinkTooltipText: {
        css: css`
            font-size: 18px;
            margin-bottom: 1.5rem;
            text-transform: inherit;
        `,
    },
    includeFirstRowCheckbox: {
        css: css`
            margin: 1rem 0 2.5rem 0;
            display: block;
        `,
    },
    uploadFileButton: {
        css: css`
            float: left;
            margin-top: 3rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0.5rem;
                        margin-bottom: 10px;
                        width: 100%;
                    `,
                    css`
                        margin-top: 0.5rem;
                        width: 100%;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                ])}
        `,
    },
    cancelUploadButton: {
        variant: "secondary",
        css: css`
            float: left;
            margin-top: 3rem;
        `,
    },
};
const commonCss = {
    css: css`
        background-color: #f0f4f3;
        color: ${getColor("primary")};
        border: none;
        border-right: 1px solid #e5e5e5;
        > ${TypographyStyle} {
            font-size: 1rem;
        }
    `,
};
orderUploadFileUploadStyles.orderUploadErrorsModalStyles = {
    rowNumberHeader: {
        css: css`
            background-color: #f0f4f3;
            color: ${getColor("primary")};
            border-radius: 8px 0 0 8px;
            border: none;
            border-right: 1px solid #e5e5e5;
            > ${TypographyStyle} {
                font-size: 1rem;
            }
        `,
    },
    itemNumberHeader: commonCss,
    qtyHeader: commonCss,
    unitOfMeasureHeader: commonCss,
    reasonHeader: {
        css: css`
            background-color: #f0f4f3;
            color: ${getColor("primary")};
            border-radius: 0 8px 8px 0;
            border: none;
            > ${TypographyStyle} {
                font-size: 1rem;
            }
        `,
    },
    tableRow: {
        evenRowCss: css`
            background-color: #fff;
        `,
        css: css`
            height: 70px;
            border-bottom: 0.5px solid #e5e5e5;
            font-size: 1rem;
        `,
    },
    dataTable: {
        css: css`
            font-size: 1rem;
        `,
    },

    continueUploadButton: {
        variant: "primary",
    },
    modal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalContent: css`
                padding: 10px;
                width: 100%;
                overflow: auto;
            `,
        },
    },
};
